import {AssistiveRegimeEnum} from '@/features/projects/types'
import {PatientAgeRange} from '@/types'
import {useMemo} from 'react'

export const useAbsenceThreshold = ({
    assistiveRegime,
    serviceType,
    totalInPresenceAccessesCount
}: {
    assistiveRegime: AssistiveRegimeEnum | null
    serviceType: Exclude<PatientAgeRange, 'evolutionary_age_adults'> | null
    totalInPresenceAccessesCount: number
}) => {
    const absenceThresholdPercentage = {
        adults: [5, 15],
        evolutionary_age: [10, 20]
    } as const satisfies Record<Exclude<PatientAgeRange, 'evolutionary_age_adults'>, [number, number]>

    const assistiveRegimeIndex = assistiveRegime === 'autism' ? 1 : 0
    const selectedAbsenceThresholdPercentage = serviceType
        ? absenceThresholdPercentage[serviceType][assistiveRegimeIndex]
        : 0

    const totalAbsencesAllowed = useMemo(() => {
        if (!selectedAbsenceThresholdPercentage || !totalInPresenceAccessesCount) return 0
        return Math.round((selectedAbsenceThresholdPercentage / 100) * totalInPresenceAccessesCount)
    }, [selectedAbsenceThresholdPercentage, totalInPresenceAccessesCount])

    return {
        selectedAbsenceThresholdPercentage,
        totalAbsencesAllowed,
        assistiveRegimeIndex
    }
}
